export default {
  getImagePathById: function(id) {
    return id.substr(-1) + '/' + id.substr(-2) + '/' + id + '.jpg';
  },

  getImageUrl: function(id) {
    if (id && (typeof id === 'string' || id instanceof String)) {
      return 'https://brest-crawler.nord-nord-ouest.com/data/archivesbrest/hd/' + this.getImagePathById(id);
    }
    return '';
  },

  getThumbImageUrl: function(url) {
    /*
    $url = str_replace('https://', '', $url);
    $url = str_replace('http://', '', $url);
    $url_parts = explode('/', $url);

    $filename = rawurldecode(end($url_parts));
    $filename = str_replace(' ', '_', $filename);
    $md5 = md5($filename);
    $folder = $md5[0] . '/' . $md5[0] . $md5[1] . '/' .  rawurlencode($filename);
    $url = 'upload.wikimedia.org/wikipedia/commons/' . $folder;

    $url_parts = explode('/', $url);
    // Insert 'thumb' url segment
    array_splice($url_parts, 3, 0, ['thumb']);
    return $url_parts;
    */
    url = url.slice(8);
    url = url.split('/');
    url.splice(3, 0, 'thumb');
    url.push('640px-' + url[(url.length - 1)]);
    url = url.join('/');
    return 'https://' + url;
  },

  capitalizeFirstLetter: function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },

  getCleanedFilterValueDisplay: function(filterValue) {
    if (filterValue === undefined || filterValue === null) return "";
    if (filterValue.hasOwnProperty("name")) return filterValue.name;
    const matches = String(filterValue).match(/(.*)\s\[Q\d+\]$/);
    return (matches && matches[1]) ? this.capitalizeFirstLetter(matches[1]) : String(filterValue);
  },
}
